import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthStore } from '@program-suite/data-auth';
import { getGreeting } from '@program-suite/util-helpers';

@Component({
  selector: 'lib-program-dashboard',
  imports: [CommonModule],
  templateUrl: './program-dashboard.component.html',
  styleUrl: './program-dashboard.component.scss',
})
export class ProgramDashboardComponent {
  userStore = inject(AuthStore);
  greeting!: string;
  firstName = computed(() => this.userStore.user()?.firstName);

  constructor() {
    this.greeting = getGreeting();
  }
}
